module.exports = __webpack_public_path__ + "static/2020_WSC_Group_PAYGW_Tax_Variation_Check_List-e26478a1ae0e86bb7a1217e6a8dabf17.pdf";